export const optionRowSx = {
  display: 'flex',
  gap: 2,
  maxWidth: 420,
};

export const optionContentSx = {
  flex: 1,
};

